import React, { useEffect, useRef } from 'react';
import ErrorFallback from './error-fallback';
const ControllerError = _ref => {
  let {
    children,
    wfConfig,
    onError
  } = _ref;
  const reportedError = useRef();
  const {
    controllerError
  } = wfConfig;
  useEffect(() => {
    var _reportedError$curren;
    if (controllerError && ((_reportedError$curren = reportedError.current) == null ? void 0 : _reportedError$curren.message) !== controllerError.message) {
      reportedError.current = {
        ...controllerError
      };
      onError == null || onError(new Error(controllerError.message));
    }
  }, [controllerError, onError]);
  if (controllerError) {
    return /*#__PURE__*/React.createElement(ErrorFallback, {
      errorMessage: controllerError.message,
      errorId: controllerError.id
    });
  }
  return children;
};
export default ControllerError;
//# sourceMappingURL=controller-error.js.map